import React from "react";
import { Button } from "@mui/material";
import { PRIMARY } from "../constants";

const editActionButtonSx = {
  fontFamily: "Rubik, sans-serif",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const EDIT_ACTION_ORDER = {
  cancel: { xs: 2, sm: 1 },
  confirm: { xs: 1, sm: 2 },
};

export function ProfileFormEditActions({ onCancelEdit, submitDisabled, order = EDIT_ACTION_ORDER }) {
  return (
    <>
      <Button
        type="button"
        variant="text"
        onClick={onCancelEdit}
        sx={{
          ...editActionButtonSx,
          color: PRIMARY,
          order: order.cancel,
        }}
      >
        Annulla
      </Button>
      <Button
        type="submit"
        variant="contained"
        disabled={submitDisabled}
        sx={{
          ...editActionButtonSx,
          backgroundColor: PRIMARY,
          borderRadius: "8px",
          px: 3,
          order: order.confirm,
          "&:hover": { backgroundColor: "#092b6a" },
        }}
      >
        Conferma
      </Button>
    </>
  );
}

export { EDIT_ACTION_ORDER };
